#     _    _                 _
#    / \  | |__   ___  _   _| |_
#   / _ \ | '_ \ / _ \| | | | __|
#  / ___ \| |_) | (_) | |_| | |_
# /_/   \_\_.__/ \___/ \__,_|\__|
#

# components/About
about:
    heading: About
    productNameLabel: Product Name
    productName: Enlivio
    manufacturerLabel: Manufacturer
    companyName: room4 Softwareentwicklung GmbH
    companyAddress: Trattnerhof 2/104, 1010 Wien, Österreich
    releaseYearLabel: Year of release
    releaseVersionLabel: Current Release Version
    intendedUse: Intended use
    reportIncident: Report an incident
    udiPiHeading: UDI-PI


#     _                             _
#    / \   ___ ___ ___  _   _ _ __ | |_
#   / _ \ / __/ __/ _ \| | | | '_ \| __|
#  / ___ \ (_| (_| (_) | |_| | | | | |_
# /_/   \_\___\___\___/ \__,_|_| |_|\__|
#

# components/MyAccount/MyAccountPage
myAccountPage:
    title: My Account
    overviewTab: Overview
    therapistSettingsTab: Public Booking
    trainingHistoryTab: Training History
    appointmentHistoryTab: Appointment History
    updateSuccess: User was successfully updated
    updateError: Saving failed. Please try again!

# components/MyAccount/Tabs/MyAccountOverview
myAccountOverview:
    patientContactOptionHeader: Contact Options
    patientContactOptionBody: Patients can see your contact information in the mobile app in order to
        contact you. They will always see your email, but you can select if your phone number should
        be shown.
    isCallAllowed: Show phone number
    isChatAllowed: Allow patient to send me a personal chat message
    yourAccountData: Your Account Data

# components/MyAccount/Tabs/TherapistSettings
therapistSettings:
    title: Public Booking
    description: Patients who do not have a physiotherapist can book first meetings directly with you.
    aboutYou: About You
    aboutYouDescription: Patients will decide who to book based on the information about you.
    selectAvatar: Change profile image
    about: Your Description
    specializations: Your specializations (please specify a maximum of 3)
    bookingBefore: Minimum booking notice (hours)
    availability: Your weekly working hours
    contract: Privacy Policy & Treatment Agreement
    contractDescription: Patients have to agree to your privacy policy and your treatment agreement if
        they want to enter a therapy relationship with you.
    privacyPolicy: Privacy Policy
    termsAndCondition: Treatment Agreement
    invalidTime: Invalid time! Please make sure that the end time is always after the start time

# api/routes/therapist (fallback when no individual text has been provided)
treatmentContractDefaults:
    privacyPolicy: >
        <p><strong>Data protection information for treatment via enlivio</strong></p> <p>The
        controller for the processing of your personal data in the context of your treatment is your
        practitioner or the institution that provides you with enlivio (hereinafter "the practice").
        You will find the contact details in the app under "My therapist".</p> <p><strong>What data
        and for what purpose:</strong> In the context of your treatment we process your master and
        contact data, the exercises and training plans assigned to you, your performance and
        progress data, treatment notes and – where used – the data from the video consultation
        (teletherapy). The purpose is the planning, delivery and documentation of your therapeutic
        treatment.</p> <p><strong>Legal basis:</strong> Processing takes place in order to perform
        the treatment contract and for the purposes of health care provided by a health professional
        (Art. 6(1)(b) and Art. 9(2)(h) GDPR) and, where necessary, on the basis of your consent
        (Art. 6(1)(a) and Art. 9(2)(a) GDPR), which you may withdraw at any time with effect for the
        future.</p> <p><strong>Technical operation (processor):</strong> The enlivio app is operated
        by room4 Softwareentwicklung GmbH, which processes your data exclusively on our behalf
        pursuant to Art. 28 GDPR. Details of the technical data processing in the app can be found
        at <a rel="noopener noreferrer" target="_blank"
        href="https://www.enlivio.com/datenschutz-app/">https://www.enlivio.com/datenschutz-app/</a>.</p>
        <p><strong>Storage and erasure:</strong> We store your treatment data for as long as it is
        required for your treatment or statutory retention obligations – in particular the
        documentation obligations in the healthcare sector – apply. Permanent retention takes place
        through our own treatment documentation or your patient file.</p> <p><strong>Your
        rights:</strong> You have the right of access, rectification, erasure, restriction of
        processing, objection and data portability, as well as the right to withdraw consent you
        have given. Please use the contact details above. You also have the right to lodge a
        complaint with the competent data protection supervisory authority (in Austria: Austrian
        Data Protection Authority, <a rel="noopener noreferrer" target="_blank"
        href="https://www.dsb.gv.at">https://www.dsb.gv.at</a>).</p>
    termsAndCondition: >
        <p><strong>Treatment agreement for the use of enlivio</strong></p> <p><strong>Subject
        matter.</strong> By giving your consent you enter into a treatment relationship with your
        practitioner or the institution that provides you with enlivio (hereinafter "the practice").
        enlivio is a digital tool to support your therapy (exercise programmes, training plans and –
        where used – video consultation/teletherapy).</p> <p><strong>A supplement, not a
        replacement.</strong> enlivio supplements your therapeutic treatment but does not replace
        any necessary in-person examination, diagnosis or acute care. The exercises provided are a
        professional recommendation addressed to you by your practitioner.</p> <p><strong>Not an
        emergency service.</strong> enlivio is not intended for emergencies. In urgent cases or
        emergencies please contact the medical on-call service or the emergency services (144 or
        112).</p> <p><strong>Your cooperation.</strong> You provide accurate information, perform
        the exercises only within your capabilities and without pain, and stop an exercise if you
        experience discomfort. If you are unsure, or if symptoms are new or increasing, please
        consult your practitioner.</p> <p><strong>State of health.</strong> Please inform your
        practitioner of any relevant pre-existing conditions, symptoms or contraindications so that
        the exercises can be safely tailored to you.</p> <p><strong>Liability.</strong> The practice
        is liable in accordance with statutory provisions. No liability is accepted for damage
        resulting from improper performance of the exercises or performance contrary to
        instructions.</p> <p><strong>Termination.</strong> You may end the treatment relationship
        via enlivio at any time. The practice's statutory retention obligations remain
        unaffected.</p> <p><strong>Data protection.</strong> The processing of your personal data is
        governed by the data protection terms of your practitioner or the institution, and by the
        app's data protection information at <a rel="noopener noreferrer" target="_blank"
        href="https://www.enlivio.com/datenschutz-app/">https://www.enlivio.com/datenschutz-app/</a>.</p>

# components/MyAccount/Tabs/TeleTherapy
teleTherapy:
    noData: There is currently no data from teletherapy
    totalTime: Total time
    duration: Duration

# components/MyAccount/Tabs/AppointmenHistory
appointmentHistory:
    title: Appointment History
    noData: There is currently no data from your appointments
    patient: Patient
    date: Date
    startTime: Start Time
    endTime: End Time
    duration: Duration

# components/accountSetup/AccountSetupForm
accountSetup:
    heading: Just one more step to your account
    personalDetailLabel: Personal Data
    choosePlanLabel: Choose Your Plan
    therapistSubheading: Please add the following details
    gisaEntry: We check your "Gesundheitsberuferegister" entry to ensure the trustworthiness of our
        platform.
    notRegistered: Not registered as a physiotherapist in Austria?
    contactUs: Contact Us
    firstName: First Name
    lastName: Last Name
    street: Street, house number
    postal: Postcode
    city: City
    telephone: Telephone Number
    dateOfBirth: Date of Birth (DD MM YYYY)
    completeRegistration: Complete Registration
    firstNameRequired: Please enter your first name.
    lastNameRequired: Please enter your last name.
    pleaseFillIn: Please fill in.
    invalidPhone: Invalid telephone number. (No space allowed)
    ageValidation: Age should be in the range of 18 to 100.
    country: Country
    countryList: Austria,Germany,Switzerland
    choosePlan: Choose your plan
    yourPlan: Your Plan
    choosePlanLinkText: more info...
    choosePlanLink: https://www.enlivio.com/wp-content/uploads/2021/11/Einzelvertrag_StarterFree_v2.pdf
    promptRequired: Please fill in!
    promptRequiredFirstName: Please fill in your first name!
    promptRequiredLastName: Please fill in your last name!
    promptValidDate: Please select a valid date!


#     _       _           _
#    / \   __| |_ __ ___ (_)_ __
#   / _ \ / _` | '_ ` _ \| | '_ \
#  / ___ \ (_| | | | | | | | | | |
# /_/   \_\__,_|_| |_| |_|_|_| |_|
#

# features/admin/pages/AdminPage
adminPage:
    therapists: Therapists
    patients: Patients
    telerehaPrograms: Telereha Programs
    exercises: Exercises
    exerciseTags: Exercise Tags
    exerciseCategories: Exercise Categories
    enduranceTrainingTypes: Endurance Training Types

# components/exercise/ExerciseManagement
adminExerciseVideo:
    tenantExercises: Own Exercises
    coreExercises: Standard Exercises

# components/exerciseCategory/ExerciseCategoryManagement
adminExerciseCategories:
    tenantCategories: Own Exercise Categories
    coreCategories: Standard Exercise Categories

# components/enduranceTrainingType/EnduranceTrainingTypeManagement
adminEnduranceTrainingTypes:
    tenantTypes: Own Training Types
    coreTypes: Standard Training Types

# components/exerciseTag/ExerciseTagManagement
adminExerciseTags:
    tenantTags: Own Exercise Tags
    coreTags: Standard Exercise Tags

# features/admin/components/TelerehabilitationPrograms
adminTelerehabilitationProgram:
    germanName: German Name
    englishName: English Name
    targetTrainingMinutes: Target Training Minutes
    maximumBillableTherapyUnits: Maximum billable therapy units incl. teletherapy
    maximumBillableTeleTherapyUnits: Maximum billable teletherapy units
    maximumEnduranceTrainingPercentage: Maximum endurance training share
    basicPackage: Basic Package
    teConversion: TE Conversion

# features/admin/components/TelerehabilitationProgramForm
telerehabilitationProgramModal:
    createTitle: Create Telereha program
    editTitle: Edit Telereha program
    germanName: German Name
    englishName: English Name
    targetTrainingMinutes: Target Training Minutes
    maximumBillableTherapyUnits: Maximum billable therapy units incl. teletherapy
    maximumBillableTeleTherapyUnits: Maximum billable teletherapy units
    maximumEnduranceTrainingPercentage: Maximum endurance training share
    basicPackage: Basic Package
    teConversion: TE Conversion


#     _                      _       _                        _
#    / \   _ __  _ __   ___ (_)_ __ | |_ _ __ ___   ___ _ __ | |_
#   / _ \ | '_ \| '_ \ / _ \| | '_ \| __| '_ ` _ \ / _ \ '_ \| __|
#  / ___ \| |_) | |_) | (_) | | | | | |_| | | | | |  __/ | | | |_
# /_/   \_\ .__/| .__/ \___/|_|_| |_|\__|_| |_| |_|\___|_| |_|\__|
#         |_|   |_|
#

# components/appointment/CreateAppointmentForm
createAppointmentForm:
    modalTitle: Create appointment
    labels:
        date: Date
        startTime: Start Time
        endTime: End Time
        submit: Create appointment
        selectDuration: Duration
        min: Min
        cancel: Cancel
        delete: Delete
        reject: Reject
        accept: Accept
        downloadIcs: Add appointment to calendar
        allTime: All
        availableTime: Available
        selectedTimeAt: from
        bookedTooltip: Booked
        noAvailableTime: No available time slots
    validation:
        date: Please enter the appointment date.
        startTime: Please enter the start time.
        endTime: Please enter the end time.
        startTimeEndTime: The end time must be after the start time.
        pastDate: Date is in the past.
        pastTime: Time is in the past.
        invalidDate: Invalid date! The correct date format is DD-MM-YYYY
    deleteModal:
        title: Delete appointment
        body: Do you really want to delete the appointment?
    acceptModal:
        title: Approve appointment
        body: Do you really want to approve the appointment?
    rejectModal:
        title: Reject appointment
        body: Do you really want to reject the appointment?
    appointmentStatus:
        pending: PENDING
        confirmed: CONFIRMED
        cancelled_by_therapist: CANCELLED
        cancelled_by_patient: CANCELLED
        rejected: REJECTED
        requested: REQUESTED
        cancelled: CANCELLED
    fcmRoomCreatedTitle: Teletherapy started
    fcmRoomCreatedBody: Your therapist has started the meeting
    fcmHostLeftTitle: Teletherapy ended
    fcmHostLeftBody: Your therapist has left the meeting
    noAppointmentData: No appointment found.
    fcmAppointmentReminderTitle: Appointment reminder
    fcmAppointmentReminderBody: Your therapy session with {first_name_of_therapist} starts in 15 minutes.


#     _         _   _
#    / \  _   _| |_| |__
#   / _ \| | | | __| '_ \
#  / ___ \ |_| | |_| | | |
# /_/   \_\__,_|\__|_| |_|
#

# components/loginSignup/LoginBoxAuth0
loginBox:
    loginSubmitLabel: Log-in
    loginSubmitLabelLoading: Logging in

# components/loginSignup/LoginPageLayout
loginPage:
    welcome: Welcome to enlivio
    patients: Patients
    therapists: Therapists
    therapistsSubHeading: Sign in to Enlivio now to continue supporting your patients online and
        digitally. Enlivio is a medical device — you can find information about its intended use
        <0>here</0>
    goToLogin: Login
    goToSignup: Create Account
    registeredAccount: Already have an account?
    noRegisteredAccount: Not yet registered?
    emailVerifiedBody: Your email has been confirmed.
    emailVerifiedButton: Ok
    joinRoomHeading: Enter the code
    joinRoomDescription: Enter the code and go to physiotherapy with 1 click
    joinRoomButton: Enter room
    joinRoomSupport: >
        Something is wrong? <br /> <a href="mailto:info@enlivio.com"> Contact our support! </a>
    joinRoomEmptyError: Please enter the room code!
    joinRoomLengthError: Please enter at least 4 characters for the room code
    notVerifiedRoomError: The room code "{{code}}" could not be found


#     _             _
#    / \__   ____ _| |_ __ _ _ __
#   / _ \ \ / / _` | __/ _` | '__|
#  / ___ \ V / (_| | || (_| | |
# /_/   \_\_/ \__,_|\__\__,_|_|
#

# components/AvatarModal
avatarModal:
    title: Upload Profile Image
    preview: Preview
    info: Click here to select a file (maximum size allowed 1MB)
    chooseFile: Choose file
    fileTooBig: The selected file exceeds the maximum file size

# components/AvatarCropper
avatarCropper:
    noImageSelected: No file selected

# components/DatePickerField
datePickerField:
    placeholder: DD.MM.YYYY
    invalidDate: Please enter a date in the format DD.MM.YYYY


#   ____      _ _
#  / ___|__ _| | |
# | |   / _` | | |
# | |__| (_| | | |
#  \____\__,_|_|_|
#

# components/call/CallPage
callPage:
    entryRoomError: The room cannot be entered at this time.
    noRoomCodeProvided: No room code provided.
    noRoomCodeInURL: No room code found in the URL.
    privacyPolicySaveError: The privacy consent could not be saved.
    live: Live
    you: You
    connecting: Connecting...
    endCallTitle: End call
    endCallBody: Do you want to end the call for all participants?
    endCallConfirm: Yes, end call
    speakingWhileMuted: You are speaking, but your microphone is muted.
    networkQuality:
        excellent: Excellent
        good: Good
        poor: Poor
        connecting: Connecting...

# components/call/CallPreview
callPreview:
    title: Welcome to Enlivio!
    subTitle: Click "Join call" to join the video call.
    camera: Camera
    microphone: Microphone
    noCameraPreviewBrowserSupport: Your browser does not support camera preview.
    cameraOrMicrophoneError: Camera or microphone could not be started. Please check your browser
        permissions and device selection.
    waitingInfoText: Please wait until the other participant joins the call.
    noPreviewAvailable: No preview available
    cameraDeactivated: Camera is disabled
    joinWithoutCamera: You can also join the call without a camera.
    loadPreview: Loading preview...
    deactivateCamera: Disable camera
    activateCamera: Enable camera
    deactivateMicrophone: Disable microphone
    activateMicrophone: Enable microphone
    roomCode: Room code
    noCameraFound: No camera found
    noMicrophoneFound: No microphone found
    joinCall: Join call
    leaveWaitingRoom: Leave waiting room

# components/call/CallFeedback
callFeedback:
    leftMessage: We're glad you were here! You have left the room.
    rejoinQuestion: Was it just a mistake?
    rejoinLink: Rejoin room
    thankYouTitle: Thank you!
    feedbackReceivedText: We have received your feedback and appreciate you taking a moment to share it with us.
    ratingTitle: How did you like the session?
    ratingSubtitle: Your short feedback helps us to improve the experience for you.
    ratingAriaLabel: Rating {{value}} out of 5
    messageTitle: Message to your therapist
    messageHint: Optional - if you would like to leave a personal message.
    messagePlaceholder: Write your message here...
    callQualityTitle: Video call quality
    callQualityHint: Were you satisfied with the audio, video and connection quality?
    improveTitle: What can we do better?
    improveHint: Optional - e.g. audio, video, connection or usability.
    improvePlaceholder: Your suggestion for improvement...
    submit: Send feedback
    footerText: Thank you and see you next time!
    skip: Continue without feedback


#   ____ _           _
#  / ___| |__   __ _| |_
# | |   | '_ \ / _` | __|
# | |___| | | | (_| | |_
#  \____|_| |_|\__,_|\__|
#

# components/chat
chat:
    sendBtn: Send
    searchPlaceholder: Search
    typeMsgPlaceholder: Type your message
    offlineLabel: Offline
    onlineLabel: Online
    therapistNameLabel: You
    chatErrorTitle: Not Authorized
    chatErrorBody: You are not connected to start the chat!
    retryButtonText: Reconnect
    noPatientFound: No Patient Found
    noChatMessageFound: No Chat Message Found
    openPatientProfile: Open Patient Profile
    sendingFailed: Sending failed. Click to retry!


#  _____
# | ____|_ __  _   _ _ __ ___
# |  _| | '_ \| | | | '_ ` _ \
# | |___| | | | |_| | | | | | |
# |_____|_| |_|\__,_|_| |_| |_|
#

# util/types (ExerciseType)
exerciseVideoTypeEnum:
    static: Static
    dynamic: Dynamic
    relaxation: Relaxation
    endurance: Endurance
    teaching: Teaching


#  _____
# | ____|_ __ _ __ ___  _ __
# |  _| | '__| '__/ _ \| '__|
# | |___| |  | | | (_) | |
# |_____|_|  |_|  \___/|_|
#

# shared/utils/errorKey (ErrorKey), aufgeloest in util/api
errorMessageTemplate:
    authError: Session Expired. Please login again!
    genericMsg: Some error occurred. Please try again!
    genericTitle: Error
    retryButtonText: Retry
    key_patientExists: User already exists
    key_noTherapistFound: No therapist found
    key_TherapyIDMissing: Therapy id is missing
    key_TherapyNotFound: Therapy not found
    key_DeletedSuccess: Deleted successfully
    key_WrongTherapy: Wrong therapist id.
    key_PatientNotFound: Patient not found
    key_FirstNameMissing: First name is missing
    key_LastNameMissing: Last name is missing
    key_EmailMissing: Email is missing
    key_PatientProfileCheck: Patient profile check is missing
    key_NoProfileFound: No Profile Found
    key_InvalidAuth0AccountId: Invalid Auth0 AccountId
    key_Unauthorized: Unauthorized Access
    key_UnauthorizedTherapist: Unauthorized Therapist Request
    key_PasswordResetEmailSent: Password reset email sent
    key_UnauthorizedPatient: Unauthorized Patient Request
    key_OnBoardingFailed: Onboarding failed.
    key_AppointmentNotFound: Appointment not found
    key_DeleteAppointmentFailed: Could not delete appointment. Please try again.
    key_DeleteAppointmentSuccess: Appointment successfully deleted
    key_InvalidInputs: Please validate your inputs
    key_TrainingNotFound: Training plan not found
    key_NoMobileAccess: Mobile Access Not Allowed
    key_InvalidPatientLogin: Invalid Patient Login
    key_InvalidCredentials: Invalid Credentials
    key_TagNotFound: Tag Not Found
    key_NoAnswerFound: No Answer Found
    key_NoQuestionFound: No Questions Found
    key_RoomCodeNotFound: Could not find room code
    key_RoomCodeChangeNotAllowed: You are not allowed to change the room code
    key_RoomAlreadyFull: The room is already full - do you have your session already connected in another tab?
    key_RoomProvidePin: You need to provide a PIN code for that room.
    key_RoomAlreadyParticipated: You already participated in that event.
    key_RoomParticipationCancelled: Your participation was cancelled.
    key_RoomWrongPin: Wrong room PIN provided.
    key_RoomTrainerNotAllowed: Trainer not allowed to join that event.
    key_RoomNoSessionFound: Unable to find session with session ID for this room code
    key_ResetPatientPassword: Activation email sent to the patient successfully
    key_profileUpdatedSuccess: Profile updated successfully
    key_TherapistMarkedAsTestUser: Therapist profile updated successfully
    key_TherapistPlanUpdatedSuccessful: Insurance plan updated successfully
    key_TemplateDeletedSuccssful: Template removed successfully
    key_TrainingTemplateSaved: Template saved successfully
    key_TrainingSavedAsDraft: Training plan saved as draft successfully
    key_TrainingSavedAsDraftFailed: Failed to save training plan. Please validate your inputs
    key_OnBoardingAnswerSavedSuccessfully: Answer saved successfully
    key_NotFound: Not found
    key_TherapistPlanUpgradeTitle: Upgrade your plan.
    key_TherapistPlanUpgradeError: Your plan only supports 2 patients. Please upgrade to the unlimited
        plan to create more patients.
    key_PatientLimitReached: Patient limit reached
    key_FeatureNotAllowed: Feature not enabled
    key_PlanCanceled: Plan cancelled successfully
    key_NoActivePlanFound: No active plan found
    key_PlanExpried: Plan Expired, Please login again to continue
    key_PatientDeletedSuccess: Patient deleted successfully
    key_CancellationAlreadySet: Patient is already cancelled
    key_CompletionConversationAlreadySet: Completion conversation is already set
    key_CompletionDocumentMissing: The completion document has to be uploaded first
    key_CompletionNotAllowed: Patient cannot be completed in this status
    key_NoActiveAppointment: No active appointment
    key_OnlyP2PCallsAllowed: Only peer-to-peer calls are allowed
    key_TherapistNotAssignedToRoom: Therapist is not assigned to the room
    key_PatientNotAssignedToAppointment: Patient is not assigned to the appointment
    key_InstantRoomNotAllowedOnMobile: Instant rooms are not allowed on mobile

# components/NotFoundPage
notFound:
    subTitle: Something went wrong
    body: The page you are looking for was moved, removed or may never have existed.
    buttonText: Back to home


#  _____                   _
# | ____|_  _____ _ __ ___(_)___  ___
# |  _| \ \/ / _ \ '__/ __| / __|/ _ \
# | |___ >  <  __/ | | (__| \__ \  __/
# |_____/_/\_\___|_|  \___|_|___/\___|
#

# components/exerciseCategory/ExerciseCategoriesTable
exerciseCategory:
    germanTitle: German Title
    englishTitle: English Title
    isActive: Active
    active: Active
    notActive: Not active

# components/exerciseCategory/ExerciseCategoryModal
exerciseCategoryModal:
    createCategory: Create Exercise Category
    updateCategory: Update Exercise Category

# components/exerciseTag/ExerciseTagTable
exerciseTag:
    germanTitle: German Title
    englishTitle: English Title
    category: Exercise Category
    isActive: Active
    active: Active
    notActive: Not active

# components/exerciseTag/ExerciseTagForm
exerciseTagForm:
    noCategories: No exercise categories found

# components/exerciseTag/ExerciseTagModal
exerciseTagModal:
    createTag: Create Exercise Tag
    updateTag: Update Exercise Tag

# components/exercise/ExerciseForm
exerciseVideo:
    media: Media
    germanTitle: German Title
    germanDescription: German Description
    englishTitle: English Title
    englishDescription: English Description
    exerciseType: Exercise Type
    isTrainingTimeBillable: Include training time in billing?
    tags: Exercise Tags
    horizontalVideo: Horizontal Video
    horizontalThumbnail: Horizontal Thumbnail
    verticalVideo: Vertical Video
    verticalThumbnail: Vertical Thumbnail
    audioFile: Audio File

# components/exercise/ExerciseModal
exerciseVideoModal:
    createExercise: Create Exercise
    updateExercise: Update Exercise

# components/enduranceTrainingType/EnduranceTrainingTypeTable
enduranceTrainingType:
    deName: German Name
    enName: English Name
    trainingMinutes: Trainings minutes
    isBillable: Is billable
    unit: Unit
    billable: Billable
    notBillable: Not billable
    excludedPromMetrics: Values not asked for
    promMetric:
        steps: Steps
        distance: Distance
        heart_rate: Heart rate

# components/enduranceTrainingType/EnduranceTrainingTypeModal
enduranceTrainingTypeModal:
    createType: Create Training Type
    updateType: Update Training Type
    noUnits: No units available

# features/training-plan/modals/TrainingExerciseModal
exerciseModal:
    title: Add exercise
    addStaticExercise: Custom exercise
    addDynamicExercise: Custom dynamic exercise
    addEnduranceExercise: Individual endurance exercise
    filterText: Filters
    filterClearText: Clear Filter
    noFilters: No filters available
    selectionDone: Add selected exercises ({{count}})
    searchInfo: Search starts automatically after entering at least 3 characters.
    searchChip: 'Search: {{searchKey}}'
    removeFilter: Remove filter
    removeSelection: Remove from selection
    selectedCount: '{{count}} selected:'
    tabTitle: '{{name}} ({{count}})'
    resultCount: '{{loaded}} of {{total}} exercises'
    loadMore: Load {{count}} more
    noResults: No exercise found.
    noResultsHint: Adjust your search or reset the filters.
    noTenantExercises: No own exercises have been created yet.
    loadError: The exercises could not be loaded.
    playPreview: Play preview
    customExercise:
        enName: Custom Exercise
        deName: Benutzerdefinierte Übung
        enDescription: Custom Exercise
        deDescription: Benutzerdefinierte Übung
    enduranceExercise:
        enName: Name of the Endurance Exercise
        deName: Name der Ausdauerübung
        enDescription: Description of the Endurance Exercise
        deDescription: Beschreibung der Ausdauerübung
    tenantExercises: Own Exercises
    coreExercises: Standard Exercises

# features/training-plan/components/ExerciseCardItem
exerciseCard:
    moveUp: Move up
    moveDown: Move down
    dragHandle: Drag to reorder
    deleteExercise:
        title: Delete exercise
        body: Are you sure you want to delete this exercise?
    validation:
        name: Please add valid name.
        exerciseType: Please select an exercise type.
        description: Please add valid description.
        greaterSets: High set count.
        lowerSets: Low set count.
        greaterRepetition: High repetition count.
        lowerRepetition: Low repetition count.
        greaterTime: High duration.
        lowerTime: Low duration.
        invalidValue: Invalid value.
    form:
        name: Exercise Name
        description: Exercise Description
        skipPause: Skip break afterwards
        skipPauseDescription: If enabled, the patient will not need to take a break after a set of this
            exercise. Use this for warmup exercises or other exercises that don’t need recovery
            time.
        sets: Sets
        repetition: Repetition
        time: Time
        timeGroup: sec
        customDescription: Custom Description
        amount: Amount
        needsVideoFeedback: Please provide feedback on the video
        dropdown:
            sec: Sec
            min: Min
            reps: Reps


#  _____             _ _                _
# |  ___|__  ___  __| | |__   __ _  ___| | __
# | |_ / _ \/ _ \/ _` | '_ \ / _` |/ __| |/ /
# |  _|  __/  __/ (_| | |_) | (_| | (__|   <
# |_|  \___|\___|\__,_|_.__/ \__,_|\___|_|\_\
#

# core-node/api/routes/feedback
feedback:
    mailSubject: "Enlivio Feedback / Room: {{roomCode}}"
    infoMailText: "The user gave {{rating}} stars. Message for the therapist: {{message}}. Suggested
        system improvements: {{improve}}."
    therapistMailText: "The user gave {{rating}} stars. Message for you: {{message}}."


#   ____                      _
#  / ___| ___ _ __   ___ _ __(_) ___
# | |  _ / _ \ '_ \ / _ \ '__| |/ __|
# | |_| |  __/ | | |  __/ |  | | (__
#  \____|\___|_| |_|\___|_|  |_|\___|
#

# app-weit verwendet
generic:
    yes: Yes
    no: No
    cancel: Cancel
    delete: Delete
    close: Close
    save: Save
    saving: Saving...
    edit: Edit
    end: End
    create: Create
    confirm: Confirm
    copy: Copy
    copied: Copied
    copiedInfo: Copied to clipboard
    pleaseChoose: Please choose
    back: Back
    archive: Archive
    approve: Approve
    reject: Reject
    loading: Loading...
    accept: Accept
    retry: Retry
    filter: Filter
    guest: Guest
    resetFilter: Reset
    hourShort: h
    teleTherapy: Teletherapy
    organizerName: Enlivio
    appointmentSubject: Enlivio Teletherapy Appointment
    fileTooBig: You are most probably trying to upload a file larger than 1MB.
    required: Required
    unknownError: Unknown Error
    chooseFile: Choose File
    search: Search...
    clearSearch: Clear search
    preview: Preview
    previousPage: Previous Page
    nextPage: Next Page
    rangeOf: "{{from}}-{{to}} of {{totalCount}}"
    noEntries: No entries
    lexicalEditorPlaceholder: Start typing...
    lexicalToolbarInsertLink: Insert link
    lexicalToolbarRemoveLink: Remove link
    lexicalToolbarLinkPrompt: Enter the link address (e.g. https://www.example.com)
    invalidFileType: Invalid file
    fileTooLarge: File too large
    openFile: Open file
    days:
        mon: Monday
        tue: Tuesday
        wed: Wednesday
        thu: Thursday
        fri: Friday
        sat: Saturday
        sun: Sunday
    fileSelected: Selected File
    openInNewTab: Open in new tab
    error: An error occurred.
    invalidEmail: Please enter a valid email address.
    unsavedChanges: Unsaved changes
    unsavedChangesConfirm: All unsaved changes will be lost. Do you really want to continue?
    leaveWithoutSaving: Leave without saving
    noUnsavedChanges: No changes


#  _                            _
# | |    __ _ _   _  ___  _   _| |_
# | |   / _` | | | |/ _ \| | | | __|
# | |__| (_| | |_| | (_) | |_| | |_
# |_____\__,_|\__, |\___/ \__,_|\__|
#             |___/
#

# components/Header
header:
    eventsNav: Groups
    imagesNav: Images
    adminNav: Admin
    superAdminNav: Super Admin
    accountNav: Account
    myAccountNav: My Account
    logoutNav: Logout
    roomsNav: Rooms
    signinNav: Sign in
    therapiesNav: Therapies
    patientsNav: Patients
    messages: Messages
    appointments: Appointments

# components/Footer
footer:
    help: Help
    about: About
    imprint: Imprint
    terms: Conditions
    privacy: Privacy
    feedback: Feedback


#  _                     _
# | |    ___  __ _  __ _| |
# | |   / _ \/ _` |/ _` | |
# | |__|  __/ (_| | (_| | |
# |_____\___|\__, |\__,_|_|
#            |___/
#

# components/PrivacyModal
privacyModal:
    contactSupport: Contact support
    iAgree: I agree
    body: >
        By using Enlivio, you agree to the following points:<br /> <span role="img"
        aria-label="lock"> 🔒 </span> The video and audio of the following therapy session are
        securely encrypted and transmitted exclusively to your therapist <br /> <span role="img"
        aria-label="lock"> 🏋️ </span> To illustrate exercises, your therapist can create, comment
        on, and make screenshots available for download <br /> <span role="img" aria-label="lock">
        🙅 </span> You can mute yourself or turn off the camera at any time. 🔏 Please note our
        information on <a rel="noopener noreferrer" href="https://www.enlivio.com/datenschutz"
        target="_blank"> data protection</a>.


#  _   _       _   _  __ _           _   _
# | \ | | ___ | |_(_)/ _(_) ___ __ _| |_(_) ___  _ __
# |  \| |/ _ \| __| | |_| |/ __/ _` | __| |/ _ \| '_ \
# | |\  | (_) | |_| |  _| | (_| (_| | |_| | (_) | | | |
# |_| \_|\___/ \__|_|_| |_|\___\__,_|\__|_|\___/|_| |_|
#

# core-node/api/routes/appointments (Push- und E-Mail-Texte)
notification:
    fcmNewDeviceLoginTitle: Alert! New Device Login.
    fcmNewDeviceLoginBody: Your account has been logged in to another device
    fcmAppointmentCreatedTitle: Appointment Created
    fcmAppointmentCancelTitle: Appointment Cancelled
    fcmAppointmentCancelBody: Your therapist has cancelled the appointment on $appointmentDateTime
    fcmAppointmentConfirmTitle: Appointment Confirmed
    fcmAppointmentConfirmBody: Your therapist has confirmed the appointment on $appointmentDateTime
    fcmAppointmentRejectTitle: Appointment Rejected
    fcmAppointmentRejectBody: Your therapist has rejected the appointment on $appointmentDateTime
    fcmAppointmentCreatedBody: Your therapist has scheduled a new appointment on $appointmentDateTime
    fcmAppointmentRemovedTitle: Appointment Cancelled
    fcmAppointmentRemovedBody: Your therapist has cancelled the appointment on $appointmentDateTime
    fcmNewChatMessageTitle: You have a new message
    fcmNewChatMessageBody: Please open the app to view and reply

# core-node E-Mail-Versand (SendGrid Template-IDs)
sendgridTemplates:
    SupportEmail: support@enlivio.com
    BookP_1_Registration: d-305c1da7b6994877b8edb74314360f71
    BookP_2_Confirmation_Offline: d-364ddfdb0c374c6ca5526e970ce23833
    BookP_2_Confirmation_Online: d-55109ee14d5042c98fd3cbaccde78f2d
    BookP_3_Reminder_Offline: d-18f615024c1742bb87afe1910e64563a
    BookP_3_Reminder_Online: d-3bb77e1585674617b0d770407e7657b6
    BookP_5_WaitingList: d-accf851aded44c3aadd8913434c0ccde
    BookP_4_ThankYouMail: d-3dac51175513483ca18f7479cbf3f7bd
    BookP_6_Cancellation: d-0a1dc4fbf9144aebbd5fabb864824746
    BookP_7_Cancellation_ByParticipant: d-cbbb828bc9b44b399b1217fd835fe71a
    BookP_8_Cancellation_OfSubscription: d-07adea67a36943e98fc18a76c9f94d6d
    BookP_9_Reminder_Online_LastMinute: d-bf18a5b5283146baaf877c3f3c842b4f
    BookP_9_Reminder_Offline_LastMinute: d-bf5f0cefcd9d44a38916ee2e217ace03
    BookT_1_NewRegistration: d-f409f50c9cc8486693dd11e56aa365a7
    BookT_1_NewRegistration_WaitingList: d-5fa0c86771024387b44e707fe1c908c2
    BookT_2_Reminder_Hybrid: d-c3efd7420941463bbb5c7b202ffdcf1a
    BookT_2_Reminder_OfflineOnly: d-49a0fd922cbe4cfc8deab2e3ea4efb34
    BookT_2_Reminder_OnlineOnly: d-de8d04b314ba4f6e9c0ea7d4e154f2af
    BookT_3_Cancellation: d-d6d826dbb2934f4c8d04bc475d4e1f35
    BookT_4_CancellationParticipant: d-e24c503ae3044f8d877fd75788bfbe3b
    BookT_5_ThankyouNote: d-0bed657083a14580adb24b8c3d32845e
    MApp_Patient_0_Welcome_Combined: 15
    MApp_Patient_Reset_Password: 18
    APP_Feedback_Email: 19
    Trainingplan_expired_DE: 20
    Therapist_FirstMail: 21
    Patient_MeetingAccepted: 24
    Patient_MeetingCancelled: 26
    Patient_MeetingRejected: 25
    Therapist_NewMeeting: 22
    Therapist_MeetingCancelled: 23
    Patient_NewMeetingByTherapist: 29
    Therapist_Chat_Notification: 35

# components/EmailValidationModal
emailValidationModal:
    title: You have not confirmed your email address yet.
    body: Before you can use Enlivio, you need to verify your email.
    sentInfo: Confirmation email sent
    resend: Resend confirmation email


#  ____       _   _            _
# |  _ \ __ _| |_(_) ___ _ __ | |_
# | |_) / _` | __| |/ _ \ '_ \| __|
# |  __/ (_| | |_| |  __/ | | | |_
# |_|   \__,_|\__|_|\___|_| |_|\__|
#

# components/appointment/AppointmentList
patients:
    createNewGroupRoom: Create new group room
    createInstantRoom: One-time room
    enterRoom: Join room
    groupRooms: Group Rooms
    editGroupRoom: Edit Group Room
    createGroupRoom: Create Group Room
    deleteGroupRoom: Delete Group Room
    deleteGroupRoomQuestion: Do you really want to delete "{{id}} {{name}}"?
    therapistBadge: TEST-ACCOUNT
    heading: Patients
    introText: <h1>Patient Overview</h1> <p>Find below a list of all patients you have added to your
        account</p> <p>Click on any patient to adjust training plans and schedule meetings.</p>
    createNewP2PRoom: Create new patient room
    createPatient: Create patient
    editPatientRoom: Edit patient room
    createPatientRoom: Create patient room
    deletePatientRoom: Delete patient room
    deletePatientRoomQuestion: Do you really want to delete {{firstName}} {{lastName}}?
    noPatients: You don’t have any patients yet.
    archivePatientTitle: Archive patient
    archivePatientBody: This patient will not be accessible anymore.
    daysRemainingLabel: Days
    searchLabel: Search
    noPatientFound: No Patient Found
    tableHeader:
        name: Name
        program: Program
        nextTherapy: Next Therapy
        trainingPlan: Training plan

# components/patient/PatientsOverview
patientsPage:
    title: Patient Overview
    info: The training information refers to the current calendar week.
    createRoom: Open One-Time Room
    createPatient: Create Patient

# components/patient/PatientRow
patientsTable:
    patient: Patient
    ssn: Social security number
    onboarding: Onboarding
    nextAppointment: Next Appointment
    status:
        title: Status
        planned: Planned
        started: Started
        completed: Completed
        cancelled: Cancelled
        completedOn: Completed on {{date}}
        cancelledOn: Cancelled on {{date}}
    trainingPlan: Training plan
    teleRehaProgram: Telereha program
    documents: Documents
    therapyBilling: Billing
    therapyBillingStatus:
        planned: Planned
        open: Open
        payed: Paid
    billed: Billed
    billedUnit_one: "{{count}} unit"
    billedUnit_other: "{{count}} units"
    therapist: Therapist
    applicationDocument: patient-application.pdf
    completionDocument: patient-completion.pdf
    documentApplicationShort: Application
    documentCompletionShort: Completion
    trainingProgress: Training Progress
    trainingMinutes: Training Minutes
    normalTraining: Training
    trainingProgressPercentage: "{{value}} %"
    trainingProgressTotal: "{{minutes}} / {{target}} min total"
    trainingProgressMinutes: "{{value}} min"
    trainingProgressEnduranceShare: of which endurance
    enduranceQuota: "Endurance allowance (max. {{percentage}} %)"
    enduranceQuotaUsed: "{{minutes}} / {{limit}} min used"
    videoCalls: Video Calls
    videoCallsDone: Completed
    videoCallsPlanned: Planned
    videoCallsBillable: Max. billable
    lastTraining: Last Training
    lastAppStart: Last App Start
    menu:
        groups:
            administration: Administration
            documents: Documents
            treatmentEnd: End of treatment
        edit: Edit Patient
        uploadApplication: Upload Patient Application
        uploadFinal: Upload Patient Completion
        export: Export Patient
        billCreate: Create Billing
        billEdit: Edit Billing
        changeTherapist: Change Therapist
        completionConversation: Set completion conversation
        completionConversationHint: Only possible once the completion document has been uploaded.
        complete: Complete Patient
        delete: Delete Patient
        cancel: Cancel Patient
        completedHint: The treatment has already been completed.
        cancelledHint: The treatment has already been cancelled.
    filter:
        onboarding:
            all: All
            onboarded: Onboarded
            notOnboarded: Not Onboarded
        status:
            all: All
        trainingPlan:
            all: All
            hasPlan: Has Plan
            noPlan: No Plan
        teleRehaProgram:
            all: All
    missingModal:
        title: Missing patient data
        body: To complete the patient record, the social security number and the start and end dates of the
            Telereha aftercare must be entered.
        buttonPositive: Add missing data

# components/patient/PatientEditModal
patientEditModal:
    title: Edit Patient

# components/patient/CreatePatientModal
patientCreateModal:
    title: Create Patient
    info: Create an account for each <0>patient</0>. After that, patients will receive an email to set
        their personal password and gain access to the mobile app. However, you can also conduct
        teletherapy sessions with patients without using the mobile app.

# components/patient/PatientForm
patientForm:
    firstName: First name
    lastName: Last name
    socialSecurityNumber: Social security number
    email: Email address
    startDate: Telereha aftercare start date
    endDate: Telereha aftercare end date
    teleRehaProgram: Telereha program
    selectTeleRehaProgram: Please select a program
    create: Create patient
    invalidSsn: Please enter a valid social security number
    invalidDates: The end date must not be before the start date

# components/patient/ContraindicationModal
contraindicationModal:
    title: Intended Use and Contraindications
    intro: Enlivio is only available for patients without contraindications. Make sure none of the
        following contraindications apply.
    body: <h1><strong>Intended Use</strong></h1> <p>Please note the intended use.</p> <p>With Enlivio,
        therapists and physicians can remotely support their patients and provide personalized
        movement therapy at home. The Enlivio software itself does not make medical or therapeutic
        decisions. All medical and therapeutic decisions, as well as the use of Enlivio for
        tele-therapeutic support, are made by qualified medical professionals (“therapist” in the
        following text). This includes professions of the higher medical-technical services (MTD),
        such as physiotherapists or occupational therapists. <br> <strong>Important:</strong> Using
        Enlivio does not replace a visit to a therapist or physician.</p>

        <p>Patients with the following characteristics can be treated with Enlivio:</p>

        <p><strong>General:</strong> Patients must be over 18 years old.</p>

        <p><strong>Medical prerequisites:</strong> The use of Enlivio is suitable only for patients
        who are medically fit for movement therapy. The decision for tele-therapeutic treatment
        always lies with the therapist. Enlivio is certified for the fields of a) Orthopedics and
        Traumatology, b) Neurology, and c) Internal Medicine as a medical device. It is important
        that Enlivio may not be used in the presence of any contraindications.</p>

        <p><strong>Technical prerequisites:</strong> Patients must own an internet-capable
        smartphone or tablet and be able to use it independently. Only devices with Android 5.0 or
        higher, or iOS 12.0 or higher, are supported. Regular software updates are required to
        ensure safe tele-therapeutic training.</p>

        <hr> <h1><strong>Contraindications</strong></h1> <p>The enlivio app can be used for various
        medical indications and specialties.</p>

        <ul> <li>Orthopedics and Traumatology</li> <li>Neurology</li> <li>Internal Medicine</li>
        </ul>

        <p>The decision regarding which patients can be treated tele-therapeutically with the app
        always lies with the treating therapist or physician. The app does not make medical
        recommendations, diagnoses, or therapeutic decisions.</p>

        <p>The enlivio app must <strong>not be used</strong> in the presence of certain
        contraindications (regardless of medical field). The table below lists these
        contraindications:</p>

        <!-- TABLE CONTENT TRANSLATED 1:1 --> <table class="table table-bordered"> <tbody> <tr>
        <td><strong>Medical Field</strong></td> <td><strong>Contraindication</strong></td> </tr>
        <tr> <td>Orthopedics and Traumatology</td> <td> <p>All types of acute
        syndromes/injuries/infections or flare-ups/exacerbations of chronic diseases</p>
        <p>Conditions requiring acute surgical or other medical intervention</p> <p>Conditions with
        acutely increased injury or mortality risk</p> <p>Systemic diseases/conditions not treatable
        by physiotherapeutic interventions</p> <p>Systemic diseases/conditions that increase injury
        risk during training (e.g., dizziness, repeated falls) or prevent proper/independent
        exercise (e.g., immobility, significant cognitive deficits)</p> <p>Training under
        (excessive) pain without adjusted pain management</p> </td> </tr>

        <tr> <td>Neurology</td> <td> <p>Neglect</p> <p>Patients with unacceptable fall risk</p>
        <p>Unacceptable cognitive impairment</p> <p>Neurodegenerative diseases or acute conditions
        preventing independent task execution</p> <p>Acute infections or exacerbations requiring
        medical treatment</p> <p>Patients who are unconscious, asleep, or otherwise significantly
        impaired in attention</p> <p>Conditions requiring hospitalization or medical monitoring</p>
        <p>Systemic diseases/conditions not treatable via physiotherapy</p> <p>Conditions requiring
        acute surgical or medical intervention</p> </td> </tr>

        <tr> <td>Internal Medicine</td> <td> <p>Patients with physical or psychological/mental
        impairments who are not sufficiently resilient or mobilizable to actively use
        tele-rehabilitation</p> <p>Acute danger to self or others</p> <p>Acute or decompensated
        conditions incompatible with rehabilitation capability (e.g., decompensated heart failure,
        severe valve insufficiency, acute pulmonary embolism, acute coronary syndrome)</p> <p>Acute
        exacerbation of COPD or chronic bronchitis</p> <p>Acute asthma exacerbation or progressive
        worsening of symptoms</p> <p>Medical conditions requiring acute surgical or medical
        intervention</p> <p>Acute infectious diseases</p> <p>Insufficient diagnostic
        clarification</p> <p>NYHA IV heart failure</p> <p>High-grade left ventricular outflow tract
        obstruction (aortic stenosis, obstructive hypertrophic cardiomyopathy)</p> </td> </tr>
        </tbody> </table>

        <p>Using enlivio cannot replace traditional in-person visits to therapists or physicians.
        For complete medical treatment, in-person consultations are required. In urgent cases,
        hospital visits may be necessary. Special legal regulations apply to medical care provided
        over the internet.</p>
    contraindicationLabel: The patient has none of these contraindications
    intendedUseLabel: The patient can be treated tele-therapeutically according to the intended use
    acceptMouseOver: Please confirm both statements first.

# components/patient/PatientFileUploadModal
patientFileUploadModal:
    uploadApplicationFile: Upload Patient Application
    uploadCompletionFile: Upload Patient Completion
    dropzoneLabel: Upload PDF

# components/patient/PatientBillingForm
patientBillingModal:
    createTitle: Create Billing
    updateTitle: Edit Billing
    unitAmount: Units to be billed
    billingStatus: Billing Status
    therapyBillingStatus:
        open: Open
        payed: Paid
        planned: Planned

# components/patient/PatientDeleteModal
patientDeleteModal:
    title: Delete Patient
    confirmText: Are you sure you want to permanently delete this patient and all related data? This
        action cannot be undone.
    delete: Delete permanently

# components/patient/PatientCancelModal
patientCancelModal:
    title: Cancel Patient
    confirmText: Are you sure you want to cancel this patient? This action cannot be undone. App access
        ends 60 days later.
    reasonLabel: Reason for cancellation (optional)
    reasonPlaceholder: Shown next to the status

# components/patient/PatientExportModal
patientExportModal:
    title: Export Patient
    description: Choose the format in which the patient data should be exported.
    excel: Excel
    pdf: PDF

# components/patient/PatientCompletionConversationModal
patientCompletionConversationModal:
    title: Set completion conversation
    confirmText: Are you sure you want to permanently set the completion conversation? This action
        cannot be undone.
    confirm: Set completion conversation

# components/patient/PatientCompleteModal
patientCompleteModal:
    title: Complete Patient
    confirmText: Are you sure you want to complete this patient? This action cannot be undone. App
        access ends 60 days later.
    confirm: Complete Patient

# core-node/services/exports/patient/patientExport.document
patientExport:
    worksheetName: Patient Export
    title: Patient export - {{tenantName}}
    subTitle: "Export created on: {{date}}"
    footer: Patient export
    patientHeader:
        patientLabel: Patient
        socialSecurityNumberLabel: Social security number
        teleRehaAftercareStartLabel: TRN start date
        teleRehaAftercareEndLabel: TRN end date
        loginLabel: Login
    generalInformationSection:
        title: General information
        teleProgramLabel: Telereha program
        therapistLabel: Therapists
        onBoardedLabel: Onboarding
        lastAppStartLabel: Last app start
        completedExerciseMinutesLabel: Completed exercise minutes
    teleRehaOverviewSection:
        title: Program overview
        maximumBillableUnitsLabel: Maximum billable services (basic package + therapy units)
        basicPackageLabel: Basic package
        maximumBillableTherapyUnitsLabel: Maximum billable therapy units incl. teletherapy
        maximumBillableTeleTherapyUnitsLabel: of which maximum billable teletherapy units
    completedServicesSection:
        title: Completed services
        completedTherapyUnitsLabel: Completed therapy units from exercises
        completedTeleTherapyUnitsLabel: Completed teletherapy
        completedServicesBillableUnitsLabel: of which billable therapy units incl. teletherapy
        completedServicesBasicPackageLabel: Basic package
    teleTherapySection:
        title: Teletherapy sessions
        teleTherapyDateHeader: Date
        teleTherapyStatusHeader: Status
        teleTherapyEmptyRow: (no teletherapy sessions available)
        outsideAftercareExplanation: Teletherapy sessions shown in italics are outside the aftercare period
            and are not included in the calculation.
        status:
            done: Completed
    therapySection:
        title: Trainings
        therapyDateHeader: Date
        therapyNameHeader: Name
        therapyStartHeader: Start
        therapyEndHeader: End
        therapyTimeHeader: Time (minutes)
        therapyEmptyRow: (no trainings available)
        therapyMinutesCapExplanation: "* A maximum of 50 training minutes per unit is displayed."
        enduranceMaxExceededExplanation: "** This exercise exceeded the maximum endurance training time."
        notBillableExplanation: "*** This endurance unit is not billable and is not included in the
            calculation."
        outsideAftercareExplanation: Trainings shown in italics are outside the aftercare period and are not
            included in the calculation.


#  ____
# |  _ \ _ __ ___  _ __ ___
# | |_) | '__/ _ \| '_ ` _ \
# |  __/| | | (_) | | | | | |
# |_|   |_|  \___/|_| |_| |_|
#

# features/therapies/components/PromQuestionDetails
promQuestionnaireDetails:
    saveSuccess: Changes saved successfully.
    question: PROM question
    title: PROM questions
    introText: Select the PROM questions that should be assigned to this patient. The questions are only
        visible after you save your selection.
    noQuestionsAvailable: No PROM questions are currently available.
    saveButton: Save changes
    saveText: Saved!
    trigger:
        after_every_training: After every training session
        weekly: Weekly
        after_endurance_training: After endurance training

# components/promQuestion/PromQuestionForm
promQuestion:
    title: Title
    questionText: Question text
    questionType: Answer type
    trigger: Trigger
    metric: Metric
    noMetric: No metric
    isActive: Active
    active: Active
    inactive: Inactive
    options: Answer options
    optionsHint: One option per line.
    rangeMin: Minimum label
    rangeMax: Maximum label
    questionTypes:
        range: Scale 0 to 10
        number: Number
        text: Free text
        multiple: Multiple choice

# components/promQuestion/PromQuestionModal
promQuestionModal:
    createQuestion: Create question
    updateQuestion: Edit question

# features/therapies/components/TrainingPlanAccordion
answerAndActivity:
    warningText: Please consider that the below data represents subjective self-assessments of the
        patient. Always talk to the patient in a therapy session before making further treatment
        decisions.
    answerTitle: Questionnaire answers
    activityTitle: Activity
    abortedText:
        not_fit: I don’t feel fit
        no_time: I have no time
        no_answer: I don’t want to answer
    noActivity: The patient has not done anything yet.
    noTrainingPlanActivity: The patient has not done anything yet.
    noAnswer: The patient has not answered any questions yet.
    effortLow: Not at all
    effortHigh: Very
    breathlessnessLow: Not at all
    breathlessnessHigh: Very
    progressLow: Not at all
    progressHigh: Very
    restrictionLow: Not at all
    restrictionHigh: Very
    painLow: Not at all
    painHigh: Very
    skipped: Skipped
    abortedLabel: Abort Reason
    generalFeedback: General Feedback
    reasonToAbort: Reason to abort
    videoFeedbackDeclineReason: Reason for no video feedback
    videoFeedbackDeclineNoAnswer: No answer
    videoFeedbacks: Video Feedbacks
    exerciseStatus:
        done: DONE
        aborted: ABORTED
        skipped: SKIPPED
        done_with_skips: DONE WITH SKIPS
    exerciseLabel: Exercise
    enduranceTrainingTypeLabel: Endurance training type
    promNoAnswer: No answer given
    trainingMinutes: Training minutes
    billable: Billable
    notBillable: Not billable
    trainingCompleted: Training sessions completed
    trainingPlanFrom: Training plan from {{startDate}} - {{endDate}}
    viewTrainingPlanBtn: View training plan
    viewTrainingPlanModal:
        workoutsPerWeek: per week
        workoutPause: seconds pause
        needsVideoFeedback: Video Feedback requested
    weekText: Week
    currentText: current
    months: January, February, March, April, May, June, July, August, September, October, November,
        December
    shortMonths: Jan, Feb, Mar, Apr, May, Jun, Jul, Aug, Sep, Oct, Nov, Dec


#  ____                             _       _           _
# / ___| _   _ _ __   ___ _ __     / \   __| |_ __ ___ (_)_ __
# \___ \| | | | '_ \ / _ \ '__|   / _ \ / _` | '_ ` _ \| | '_ \
#  ___) | |_| | |_) |  __/ |     / ___ \ (_| | | | | | | | | | |
# |____/ \__,_| .__/ \___|_|    /_/   \_\__,_|_| |_| |_|_|_| |_|
#             |_|
#

# features/superAdmin/pages/SuperAdminPage
superAdminPage:
    exercises: Exercises
    exerciseTags: Exercise Tags
    exerciseCategories: Exercise Categories
    tenantSettings: Tenant Settings
    enduranceTrainingTypes: Endurance Training Types
    promQuestions: Prom Questions

# router/gates/TenantSettingsGate
tenantSettingsGate:
    loading: Loading tenant settings...
    error: Failed to load tenant settings.
    noDataAvailable: Tenant settings are not available.

# features/superAdmin/components/TenantSettings
superAdminTenantSettings:
    loading: Loading settings...
    error: Failed to load settings.
    title: Tenant Settings
    description: Manage the settings for this tenant.
    videoFeedbackLabel: Video Feedback enabled
    videoFeedbackTitle: Video feedback
    videoFeedbackDescription: Allow feedback after video sessions.
    maxTrainingCountTitle: Maximum number of trainings
    maxTrainingCountDescription: Maximum number of trainings allowed per tenant.
    maxTrainingCountLabel: Maximum number
    maxTrainingCountInvalid: Please enter a number between {{min}} and {{max}}.
    success: Settings saved successfully.
    saveError: Failed to save settings.
    udiDiTitle: UDI-DI (GTIN)
    udiDiDescription: GTIN (01) per platform. Leave empty to hide the UDI-PI.
    udiWebLabel: Web
    udiAndroidLabel: Android
    udiIosLabel: iOS


#  _____ _                          _     _
# |_   _| |__   ___ _ __ __ _ _ __ (_)___| |_
#   | | | '_ \ / _ \ '__/ _` | '_ \| / __| __|
#   | | | | | |  __/ | | (_| | |_) | \__ \ |_
#   |_| |_| |_|\___|_|  \__,_| .__/|_|___/\__|
#                            |_|
#

# features/admin/components/Therapists
therapists:
    empty: No therapists found
    error: Therapists could not be loaded
    table:
        therapist: Therapist
        plannedAppointments: Planned appointments
        doneAppointments: Completed appointments
        sessions: Number of video calls
        patients: Number of patients
        lastLoginAt: Last login
        details: Details

# features/admin/components/TherapistDetailsModal
therapistDetailsModal:
    title: Therapist details
    active: Active
    blocked: Blocked
    block: Block
    unblock: Unblock
    profileInfo: Profile information
    auth0Id: Auth0 ID
    onSchedResourceId: OnSched Resource ID
    lastLoginAt: Last login
    personalDetails: Personal information
    firstName: First name
    lastName: Last name
    email: Email
    birthDate: Birthday
    sessionsByDate: Sessions by date
    sessionsByPatient: Sessions by patient
    day: Day
    durationInHours: Duration
    patientId: Patient ID
    patient: Patient
    noData: No data available
    error: Therapist details could not be loaded
    actionError: The action could not be completed
    empty: No therapist selected
    unknownPatient: Not assigned

# components/patient/ChangeTherapistModal
changeTherapistModal:
    title: Change Therapist
    info: After the change, the newly selected therapist will be responsible for the patient's further
        care. All existing training plans, therapies, and progress data will remain fully unchanged.

# components/patient/ChangeTherapistForm
changeTherapistForm:
    therapistId: New Therapist
    therapistIdPlaceholder: Choose new therapist
    save: Change Therapist


#  _____ _
# |_   _| |__   ___ _ __ __ _ _ __  _   _
#   | | | '_ \ / _ \ '__/ _` | '_ \| | | |
#   | | | | | |  __/ | | (_| | |_) | |_| |
#   |_| |_| |_|\___|_|  \__,_| .__/ \__, |
#                            |_|    |___/
#

# features/therapies/pages/TherapyDetailsPage
therapyDetails:
    status:
        activated: Activated
        pending: Pending activation
    appointments:
        title: Appointments
        button: New Appointment
        requestTitle: Appointment Request
        empty: No appointments scheduled yet.
        description: Schedule and manage video appointments with the patient.
    meetings:
        title: Course
    workouts:
        title: Training plan
        description: Review the current training plan or make changes.
    questionnaire:
        title: Questionnaire
        description: Choose which PROM questions are assigned to this patient.
    answerAndActivity:
        title: Questionnaire answers & Activity
        description: Questionnaire responses and training activity over time.
    resendActivationEmail:
        button: Resend Activation E-Mail
        body: Patient has not activated their account yet. You can resend an activation email, which will be
            sent to <strong>{{email}}</strong>.
        successMsg: Activation email sent to {{email}} successfully.
        errorMsg: The activation email could not be sent. Please try again.

# components/UpgradeNotification
planDetails:
    currencySymbol: €
    planButton: Start Now
    confirmPlanTitle: Proceed to create profile
    confirmPlanBody: Your plan will start automatically on {planStartDate}.
    planConfirmButton: Finish
    planCancelButton: Cancel
    choosePlanLabel: Choose Your Plan
    currentPlan: Current Plan
    upgradePlanButton: Upgrade plan
    upgradeCancelButton: Cancel
    nextPaymentLabel: "Price: {price} / month"
    planWillBeCanceled: Your plan has been cancelled and will not be renewed after {endDate}
    cancelSubscription: Cancel subscription
    upgradeModalTitle: Upgrade plan
    upgradeSuccessTitle: Plan Upgraded Successfully
    upgradeSuccessBody: You will be notified via email
    cancelModalTitle: Do you really want to cancel?
    cancelModalBody: If you cancel, your subscription will be cancelled on {endDate}. You will not be
        able to access your account anymore.
    cancelButton: Cancel subscription
    cancelSuccessTitle: Your plan has been cancelled
    cancelSuccessBody: You will be notified via email


#  _____          _       _               ____  _
# |_   _| __ __ _(_)_ __ (_)_ __   __ _  |  _ \| | __ _ _ __
#   | || '__/ _` | | '_ \| | '_ \ / _` | | |_) | |/ _` | '_ \
#   | || | | (_| | | | | | | | | | (_| | |  __/| | (_| | | | |
#   |_||_|  \__,_|_|_| |_|_|_| |_|\__, | |_|   |_|\__,_|_| |_|
#                                 |___/
#

# features/training-plan/components/TrainingPlanDetails
trainingPlan:
    labels:
        trainingInterval: "Training interval:"
        activeExercise: "{{index}}. Exercise"
        repetitions: "Repetitions:"
        sets: "Sets:"
        comment: "Comment:"
        downloadPdf: Download PDF (password protected)
    unpublish:
        title: Unpublish training plan
        body: Your patient will not be able to do their exercises until you publish the training plan again.
        button: Unpublish
    createNewConfirm:
        title: Create new training plan
        body: The current plan will be unpublished and a new draft based on the current exercises will be
            created. Do you want to continue?
        button: Create new plan
    trainingPlanFor: Training plan for
    trainingPlanGenericError: There are some errors in the trainings listed below. Please check all
        exercise and training settings.
    tabLabel: Tab
    status:
        unpublished: Unpublished
        published: Published
        draft: Draft
    publishUntil: Published until
    unpublishedSince: Unpublished since
    newTabTraining: Training
    publish: Publish
    saveAsDraft: Save draft
    createNew: Create new plan
    saveAndPublish: Save and publish
    deleteTrainingTitle: Delete training
    deleteTrainingBody: Are you sure you want to delete this training?
    saveAndPublishModal:
        body: The training plan will be published for the specified timeframe
        label: Valid until
        isGlobalLabel: Save As Global Template?
        templateLabel: Category
        templatePlaceHolder: e.g. Back Pain
        templateHelpText: The category name will be used so that you can better find your templates again.
    validation:
        date: Invalid date
        greaterDate: Cannot select a date more than 4 weeks in the future
        pastDate: Cannot select past date
        templateName: Category name is required
        futureDate: A date more than 2 months in the future cannot be selected
        invalidDate: Invalid date! The correct date format is DD-MM-YYYY
    unSavedWarning: All unsaved changes will be lost. Continue?
    toast:
        saved: Training plan saved
        published: Training plan published
        unpublished: Training plan unpublished

# features/training-plan/components/TrainingPlanForm
trainingPlanForm:
    title: Trainings
    tabHasErrors: This training has incomplete entries
    addTraining: Add training
    addNormalTraining: Training
    addEnduranceTraining: Endurance training
    addExercise: Add exercise
    enduranceType: Endurance training type
    enduranceTypeValidation: Please select an endurance training type.
    enduranceDescription: Description
    trainingDetails: Training details
    loadTemplate: Load template
    saveAsTemplateTitle: Save as training template
    saveAsTemplate: Save as template
    templateModalTitle: Load Template
    templateModalButton: Add Selected Template
    templateModalError: Max 4 trainings can be added to a training plan. Please delete some before adding.
    templateModalNoTemplate: Template not found
    templateModalConfirm: Confirm?
    perWeek: "{{count}} x per week"
    trainingName: Training name
    trainingNameValidation: Please provide a valid name.
    workoutsPerWeek: Workouts per week
    workoutsPerWeekValidation: Only values between 1 and 7 accepted.
    workoutPause: Pause between exercises
    workoutPauseValidation: Please add at least 10 sec. of pause.
    needsFeedback: Video Feedback
    deleteTraining: Delete training
    deleteTrainingBody: Are you sure you want to delete this training?
    exercise: Exercises
    noExercise: No exercises yet.
    pauseGroup: seconds
    yourTemplateText: Your Template
    globalTemplateText: Global Template
    deleteTemplateTitle: Delete template
    deleteTemplateBody: Are you sure you want to delete template {templateName}?
    exerciseValidation: At least one exercise is required


# __        __         _               _
# \ \      / /__  _ __| | _____  _   _| |_
#  \ \ /\ / / _ \| '__| |/ / _ \| | | | __|
#   \ V  V / (_) | |  |   < (_) | |_| | |_
#    \_/\_/ \___/|_|  |_|\_\___/ \__,_|\__|
#

# core-node/api/routes/trainingplan (FCM-Texte)
workouts:
    introText: >
        <h1>Training plan</h1> <p>A training plan allows your patient to exercise alone at home
        using the app.</p>
    createTraining: Create training plan
    editTraining: Edit training plan
    workoutCreateFCMTitle: New training plan
    workoutCreateFCMBody: Your therapist has published a new training plan for you
    workoutUnpublishedFCMTitle: Training plan unpublished
    workoutUnpublishedFCMBody: Your therapist has unpublished the training plan for you
    warningOneExercise: A training plan must contain at least one exercise.
